import React from "react";
import { Link, useParams } from "react-router-dom";
import { JOBS } from "../Careers/jobsData";

const Section1 = () => {
  const { jobId } = useParams();
  const job = JOBS.find((j) => j.id === jobId);

  if (!job) {
    return (
      <section className="job-details-section-1">
        <div className="container job-not-found">
          <h1>Role Not Found</h1>
          <p>The role you're looking for is no longer open or doesn't exist.</p>
          <Link to="/careers" className="back-to-careers-btn">
            ← Back To Careers
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section className="job-details-section-1">
      <div className="container job-details-container">
        <Link to="/careers" className="back-to-careers-btn">
          ← Back To Careers
        </Link>

        <h1 className="job-title">{job.title}</h1>

        <p className="job-description">{job.description}</p>

        <div className="job-details-block">
          <h2>Responsibilities:</h2>
          <ul>
            {job.responsibilities.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="job-details-block">
          <h2>Experience:</h2>
          <p className="experience-line">{job.experience.minimum}</p>
          <p className="timings-label">Timings:</p>
          <p className="experience-line">{job.experience.timings}</p>
        </div>

        <div className="job-details-block">
          <h2>About Us:</h2>
          <p>{job.aboutUs}</p>
        </div>

        <div className="job-details-block">
          <h2>What we offer:</h2>
          <ul>
            {job.whatWeOffer.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>

        <a
          className="apply-job-btn"
          href={`mailto:contact@exd.com?subject=${encodeURIComponent(
            `Application - ${job.title}`
          )}`}
        >
          Apply For The Job
        </a>
      </div>
    </section>
  );
};

export default Section1;
